import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { motion } from "framer-motion/dist/framer-motion";
export var VISIBILITY = "VISIBILITY";
export var poses = _defineProperty({}, VISIBILITY, {
  initialState: "hidden",
  endState: "visible",
  MotionContainer: motion.div,
  variants: {
    visible: {
      opacity: 1,
      height: "auto"
    },
    hidden: {
      opacity: 0,
      height: "0"
    }
  }
});
export var animationTypes = [VISIBILITY];